// extracted by mini-css-extract-plugin
export default {"header":"_3pal6yT-","getStartedButton":"_3xM-lPal","howItWorksButton":"_3vPY5M5u","getStarted":"PpTB5JaY"};